// extracted by mini-css-extract-plugin
export default {"newFormUsersOnly":"UpdateUser_newFormUsersOnly__jSihm"};